import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Clickable, Row, Text } from 'components';

const HighlightedText = styled.span`
  font-weight: 700;
  font-size: 14px;
  ${({ col }) => col && `color: ${col};`}
  ${({ underline }) => underline && 'text-decoration: underline;'}
`;

/*
  "By registering you agree to our Terms and Conditions and Privacy Policy"
  with both documents linked. Shared by the signup modals and the CTA flow.
*/
const TermsAgreement = ({ col, underline, marg = '16px 0 0 0', maxWid }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Row rowWrap marg={marg} center maxWid={maxWid}>
      <Text b2 center col={col}>
        {t('common.byRegisteringAgree')}{' '}
      </Text>
      <Clickable
        style={{ display: 'inline', margin: '0 3px' }}
        onClick={() => navigate('/terms-and-conditions')}
      >
        <HighlightedText col={col} underline={underline}>
          {t('common.termsAndConditions')}
        </HighlightedText>
      </Clickable>
      <Text b2 center marg="2px 0 0 0" col={col}>
        {t('common.and')}
      </Text>
      <Clickable
        style={{ display: 'inline', margin: '0 3px' }}
        onClick={() => navigate('/privacy-policy')}
      >
        <HighlightedText col={col} underline={underline}>
          {t('common.privacyPolicy')}.
        </HighlightedText>
      </Clickable>
    </Row>
  );
};

export default TermsAgreement;
